import 'vue2-dropzone/dist/vue2Dropzone.min.css'
